import { TERMS_LINKS } from '@avalara/bat-apps-shared/constants';

import { translate } from '@avalara/bat-apps-shared/i18n';
import type { Dispatch } from '@avalara/types/actions';
import type { InitialAddObligationsOptions } from '@avalara/types/index';

import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';

import { isFormIncomplete } from '../../lib/shared-signup';
import { createNetNewSTRAAccount } from '../../lib/side-effects/accounts';
import { addRiskAssessmentOffer } from '../../lib/side-effects/offers';
import { selectIsNonAdmin, selectState } from '../../selectors';
import ExternalLink from '../external-link';

type Props = {
  showConnectors?: boolean;
};

const BuyButton = ({ showConnectors }: Props) => {
  const {
    account: { isLoggedIn },
    data: {
      marketingData: { connector },
    },
    order: { discountAdditionalLegalText },
    sharedSignup,
  } = useSelector(selectState);
  const dispatch = useDispatch<Dispatch>();
  const history = useHistory();

  const formIncomplete = isFormIncomplete(sharedSignup);
  const isNonAdmin = useSelector(selectIsNonAdmin);
  const missingConnector = showConnectors && !connector;
  const disabled = formIncomplete || (isLoggedIn && isNonAdmin) || missingConnector;

  const onSubmit = () => {
    const options: InitialAddObligationsOptions = {
      history,
      paymentToken: '',
    };
    if (!isLoggedIn) {
      dispatch(createNetNewSTRAAccount(options));
    } else {
      dispatch(addRiskAssessmentOffer(options));
    }
  };

  const buyButtonText = 'Claim now';

  return (
    <div className='pad-top-md margin-all-sm'>
      <div className='get-started-button-container'>
        <button
          type='button'
          data-ref='buy.risk-assessment.submit-button'
          id='submit-payment'
          disabled={disabled}
          onClick={onSubmit}
          className='button primary large buy-now margin-bottom-md'
        >
          {buyButtonText}
        </button>
      </div>
      <div className='get-started-text-link'>
        {translate('client.disclaimer.by-clicking-accept-terms-and-ps', {
          buttonText: buyButtonText,
          termsLink: (chunks) => (
            <ExternalLink href={TERMS_LINKS.esow} alwaysOpenInNewTab>
              {chunks}
            </ExternalLink>
          ),
          professionalServicesLink: (chunks) => (
            <ExternalLink href={TERMS_LINKS.ps} alwaysOpenInNewTab>
              {chunks}
            </ExternalLink>
          ),
        })}
      </div>
      {discountAdditionalLegalText != null && (
        <p className='margin-top-sm' data-ref='risk-assessment.buy-button.legal-text'>
          {discountAdditionalLegalText}
        </p>
      )}
    </div>
  );
};

export default BuyButton;
